export const isFuneralHomeClosed = (funeralHomeInfo: { closedAt?: Date | null }) =>
  Boolean(funeralHomeInfo.closedAt);

//* 새로 고르는 화면(부고 작성·문의)용. 기존 부고·주문은 id로 직접 참조하므로 영향 없다
export const excludeClosedFuneralHomes = <T extends { closedAt?: Date | null }>(
  funeralHomeInfoList: T[],
) => funeralHomeInfoList.filter((item) => !isFuneralHomeClosed(item));
